import { useState } from "react"
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes"
import { Box, Tab, Tabs } from "@mui/material"
import TabPanel from "../ui/TabPanel"
import { Fees } from "./Fees"
import { Leave } from "./Leave"
import { Income } from "./Income"
import { Expense } from "./Expense"

export const Approvals = ({tab}) => {
  const [value, setValue] = useState(tab || 0)
  const navigate = useNavigate()
  const handleChange = (_, newValue) => {
    setValue(newValue)
    switch(newValue) {
      case 0:
        navigate(routes.CLASSES.FEES, {replace: true})
        break
      case 1:
        navigate(routes.CLASSES.LEAVE, {replace: true})
        break
      case 2:
        navigate(routes.CLASSES.INCOME, {replace: true})
        break
      case 3:
        navigate(routes.CLASSES.EXPENSE, {replace: true})
        break  
      default:
        navigate(routes.CLASSES.FEES, {replace: true})
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: "#f8f8f8",
        display: "flex",
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        style={{ paddingTop: "1rem", width: "15rem" }}
      >
        <Tab
          style={{ background: value === 0 ? "white" : "" }}
          label="Fees"
        />
        <Tab label="Leave" style={{ background: value === 1 ? "white" : "" }} />
        <Tab label="Income" style={{ background: value === 2 ? "white" : "" }} />
        <Tab label="Expense" style={{ background: value === 3 ? "white" : "" }} />
      </Tabs>

      <TabPanel value={value} index={0}>
        <Fees />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Leave />
      </TabPanel>
      <TabPanel value={value} index={2}>
      <Income />
      </TabPanel>
      <TabPanel value={value} index={3}>
      <Expense />
      </TabPanel>
    </Box>
  )
}
export default Approvals